import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const ShareIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 0 20.8 21.999"
    >
      <g transform="translate(1 1)">
        <line
          y1="3.73"
          x2="6.816"
          transform="translate(5.983 4.666)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x1="6.94"
          y1="3.797"
          transform="translate(5.94 11.581)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <circle
          cx="3.052"
          cy="3.052"
          r="3.052"
          transform="translate(12.696 13.895)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <circle
          cx="3.052"
          cy="3.052"
          r="3.052"
          transform="translate(12.696)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <circle
          cx="3.052"
          cy="3.052"
          r="3.052"
          transform="translate(0 6.948)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
